import React, { useState, useCallback, useEffect } from 'react';
import { useFirestore } from '../../hooks/useFirestore';
import { getHeroContent } from '../../firebase/firestore';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import Button from '../../components/common/Button';
import Loading from '../../components/common/Loading';
import './ManageHero.css';

const ManageHero = () => {
    const { data: heroContent, loading, refresh } = useFirestore(useCallback(() => getHeroContent(), []));
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        titleAr: '',
        titleEn: '',
        subtitleAr: '',
        subtitleEn: '',
    });

    useEffect(() => {
        if (heroContent) {
            setFormData({
                titleAr: heroContent.titleAr || '',
                titleEn: heroContent.titleEn || '',
                subtitleAr: heroContent.subtitleAr || '',
                subtitleEn: heroContent.subtitleEn || '',
                slide2TitleAr: heroContent.slide2TitleAr || 'جودة لا تضاهى',
                slide2TitleEn: heroContent.slide2TitleEn || 'Unmatched Quality',
                slide2SubtitleAr: heroContent.slide2SubtitleAr || 'أحدث التقنيات العالمية في عالم المصاعد والسلالم المتحركة',
                slide2SubtitleEn: heroContent.slide2SubtitleEn || 'The latest international technologies in elevators and escalators',
                slide3TitleAr: heroContent.slide3TitleAr || 'أمان متناهي',
                slide3TitleEn: heroContent.slide3TitleEn || 'Ultimate Safety',
                slide3SubtitleAr: heroContent.slide3SubtitleAr || 'نلتزم بأعلى معايير السلامة والجودة لضمان راحتكم',
                slide3SubtitleEn: heroContent.slide3SubtitleEn || 'We are committed to the highest safety and quality standards to ensure your comfort',
            });
        }
    }, [heroContent]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await updateDoc(doc(db, 'siteContent', 'hero'), formData);
            alert('تم تحديث محتوى الواجهة الرئيسية بنجاح');
            refresh();
        } catch (error) {
            console.error('Error updating hero content:', error);
            alert('فشل تحديث البيانات.');
        } finally {
            setSubmitting(false);
        }
    };

    if (loading && !heroContent) return <Loading />;

    const renderSlideForm = (num, title) => (
        <section className="form-section">
            <h3>{title}</h3>
            <div className="form-group">
                <label>العنوان {num === 1 ? 'الرئيسي' : ''} بالعربية</label>
                <input
                    type="text"
                    required
                    value={num === 1 ? formData.titleAr : formData[`slide${num}TitleAr`]}
                    onChange={(e) => setFormData({ ...formData, [num === 1 ? 'titleAr' : `slide${num}TitleAr`]: e.target.value })}
                />
            </div>
            <div className="form-group">
                <label>{num === 1 ? 'Main ' : ''}Title (English)</label>
                <input
                    type="text"
                    required
                    value={num === 1 ? formData.titleEn : formData[`slide${num}TitleEn`]}
                    onChange={(e) => setFormData({ ...formData, [num === 1 ? 'titleEn' : `slide${num}TitleEn`]: e.target.value })}
                />
            </div>

            <div className="form-group">
                <label>العنوان الفرعي بالعربية</label>
                <textarea
                    rows="2"
                    required
                    value={num === 1 ? formData.subtitleAr : formData[`slide${num}SubtitleAr`]}
                    onChange={(e) => setFormData({ ...formData, [num === 1 ? 'subtitleAr' : `slide${num}SubtitleAr`]: e.target.value })}
                ></textarea>
            </div>
            <div className="form-group">
                <label>Subtitle (English)</label>
                <textarea
                    rows="2"
                    required
                    value={num === 1 ? formData.subtitleEn : formData[`slide${num}SubtitleEn`]}
                    onChange={(e) => setFormData({ ...formData, [num === 1 ? 'subtitleEn' : `slide${num}SubtitleEn`]: e.target.value })}
                ></textarea>
            </div>
        </section>
    );

    return (
        <div className="manage-hero">
            <h1 className="admin-page-title">إدارة الواجهة الرئيسية</h1>

            <form onSubmit={handleSubmit} className="admin-form-container shadow-premium">
                {renderSlideForm(1, 'نصوص الشريحة الأولى')}
                {renderSlideForm(2, 'نصوص الشريحة الثانية')}
                {renderSlideForm(3, 'نصوص الشريحة الثالثة')}

                <div className="form-actions">
                    <Button type="submit" variant="primary" disabled={submitting}>
                        {submitting ? 'جاري الحفظ...' : 'حفظ التغييرات'}
                    </Button>
                </div>
            </form>
        </div>
    );
};

export default ManageHero;
